import {ip_back , api_key} from '../constants/appConstants';

export const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]); // Obtener solo el contenido base64 sin el prefijo "data:..."
      reader.onerror = (error) => reject(error);
    });
  };

export const descargarDocumento = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(ip_back + '/api/clientes/obtener_contenido_documento?id='+id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error al descargar documento: ${response.statusText}`);
      }
  
      const data = await response.json();
      const nombre = data.nombre;
      const contenido = data.contenido;
      const extension = data.extension;
  
      // Crear un enlace temporal para la descarga
      const enlaceDescarga = document.createElement('a');
      enlaceDescarga.href = `data:application/${extension};base64,${contenido}`;
      enlaceDescarga.download = nombre;
      document.body.appendChild(enlaceDescarga);
      enlaceDescarga.click();
      document.body.removeChild(enlaceDescarga);
  
      console.log('Documento descargado con éxito');
    } catch (error) {
      console.error('Error al descargar el documento:', error);
    }
  };

export const descargarDocumentoSiniestro = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(ip_back + '/api/siniestros/obtenerContenidoDocumento?id='+id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error al descargar documento: ${response.statusText}`);
      }
  
      const data = await response.json();
      const nombre = data.nombre;
      const contenido = data.contenido;
      const extension = data.extension;
  
      // Crear un enlace temporal para la descarga
      const enlaceDescarga = document.createElement('a');
      enlaceDescarga.href = `data:application/${extension};base64,${contenido}`;
      enlaceDescarga.download = nombre;
      document.body.appendChild(enlaceDescarga);
      enlaceDescarga.click();
      document.body.removeChild(enlaceDescarga);
  
      console.log('Documento descargado con éxito');
    } catch (error) {
      console.error('Error al descargar el documento:', error);
    }
  };

export const descargarDocumentoPoliza = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(ip_back + '/api/polizas/obtenerContenidoDocumento?id='+id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error al descargar documento: ${response.statusText}`);
      }
  
      const data = await response.json();
      const nombre = data.nombre;
      const contenido = data.contenido;
      const extension = data.extension;
  
      // Crear un enlace temporal para la descarga
      const enlaceDescarga = document.createElement('a');
      enlaceDescarga.href = `data:application/${extension};base64,${contenido}`;
      enlaceDescarga.download = nombre;
      document.body.appendChild(enlaceDescarga);
      enlaceDescarga.click();
      document.body.removeChild(enlaceDescarga);
  
      console.log('Documento descargado con éxito');
    } catch (error) {
      console.error('Error al descargar el documento:', error);
    }
  };

  export const descargarDocumentoClientePotencial = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(ip_back + '/api/clientesPotenciales/obtener_contenido_documento?id='+id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error al descargar documento: ${response.statusText}`);
      }
  
      const data = await response.json();
      const nombre = data.nombre;
      const contenido = data.contenido;
      const extension = data.extension;
  
      // Crear un enlace temporal para la descarga
      const enlaceDescarga = document.createElement('a');
      enlaceDescarga.href = `data:application/${extension};base64,${contenido}`;
      enlaceDescarga.download = nombre;
      document.body.appendChild(enlaceDescarga);
      enlaceDescarga.click();
      document.body.removeChild(enlaceDescarga);
  
      console.log('Documento descargado con éxito');
    } catch (error) {
      console.error('Error al descargar el documento:', error);
    }
  };

export const convertirFechaParaInputDate = (fechaApi) => {
    const date = new Date(fechaApi);
    return date.toISOString().split('T')[0]; // devuelve '2025-10-24'
  };